var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Snake",style:({width:(_vm.width+2)*10+'px'})},_vm._l((_vm.list),function(val,key){return _c('div',{key:key,class:val.type==1?'qiang':(val.l==_vm.red.l&&val.t==_vm.red.t)?'red':''})}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f977f08","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Snake.vue
// module id = null
// module chunks = 